"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    root: {
        backgroundColor: '#51748b',
        borderRadius: 10,
        padding: theme.spacing(3),
        marginTop: theme.spacing(3)
    },
    lightText: {
        color: theme.palette.common.white
    },
    bold: {
        fontWeight: 'bold'
    },
    section: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: theme.spacing(2)
    },
    instructions: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    star: {
        width: 59,
        height: 61
    },
    eligibleGames: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(9),
        backgroundColor: theme.palette.common.white.getWithAlpha(0.9)
    },
    eligibleGamesSection: {
        padding: theme.spacing(3),
        paddingBottom: 0,
        marginBottom: theme.spacing(2)
    },
    gameMedia: {
        height: 250,
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
            height: 204.5
        },
        [theme.breakpoints.down('md')]: {
            height: 305
        },
        [theme.breakpoints.down('xs')]: {
            height: 314
        }
    },
    ticketEntry: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    ticketEntryButton: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8)
    }
}));
exports.default = useStyles;
//# sourceMappingURL=SuperBonusEligibleGamesStyle.js.map